import * as yup from 'yup'

const REQUIRED_FIELD_MSG = 'This field is required.'
const INVALID_EMAIL = 'Invalid email format.'
export enum FIELDS {
  EMAIL = 'email',
}

export const schema = yup
  .object({
    [FIELDS.EMAIL]: yup.string().trim().required(REQUIRED_FIELD_MSG).email(INVALID_EMAIL),
  })
  .required()
